import React from "react";
import { Box, InputBase } from "@mui/material";

const SearchInput = ({ placeholder, value, onChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        border: "1px solid #ccc",
         fontFamily: 'Poppins, sans-serif',
        borderRadius: "6px",
        px: 1.5,
        py: 0.5,
        width: "100%",
        background: "#fff",
      }}
    >      <InputBase
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        sx={{
          fontSize: 14,
             fontFamily: 'Poppins, sans-serif',
        borderRadius: "6px",
        }}
      />
    </Box>
  );
};

export default SearchInput;
